gsap.registerPlugin(ScrollTrigger);

function initAnimCasesPremiados() {
    const track = document.querySelector('.ribbon-text-track');

    if (track) {
        gsap.to(track, {
            x: '-50%',
            duration: 50,
            ease: 'none',
            repeat: -1
        });
    }
}

function initSobreStallAnimation() {
    gsap.registerPlugin(ScrollTrigger);

    const section = document.querySelector('.sobre-sobre');
    const stall = document.querySelector('#stall');
    const scroller = document.querySelector('.scroller');

    if (!section || !stall) {
        return;
    }

    const paragraphs = gsap.utils.toArray('.sobre-sobre__paragraphs p');

    gsap.set(paragraphs, { autoAlpha: 0, y: 30 });
    gsap.set(paragraphs[0], { autoAlpha: 1, y: 0 });

    const tl = gsap.timeline();

    paragraphs.forEach((p, index) => {
        if (index === paragraphs.length - 1) return;

        const currentParagraph = paragraphs[index];
        const nextParagraph = paragraphs[index + 1];

        tl
            .to({}, { duration: 1 })
            .to(currentParagraph, {
                autoAlpha: 0,
                y: -30,
                duration: 0.5
            }, '+=0.5')
            .to(nextParagraph, {
                autoAlpha: 1,
                y: 0,
                duration: 0.5
            });
    });

    ScrollTrigger.create({
        animation: tl,
        trigger: section,
        pin: scroller,
        start: 'center center',
        end: '+=1200',
        scrub: 1,
        markers: false
    });
}

function initHomeStallAnimation() {

    const section = document.querySelector('.home-sobre');
    const stall = document.querySelector('#stall');

    if (!section || !stall) {
        return;
    }

    const paragraphs = gsap.utils.toArray('.home-sobre__paragraphs p');

    gsap.set(paragraphs, { autoAlpha: 1 });
    const heights = paragraphs.map(p => p.offsetHeight);
    gsap.set(paragraphs, { autoAlpha: 0, y: 30 });
    gsap.set(paragraphs[0], { autoAlpha: 1, y: 0 });

    gsap.set(stall, { height: heights[0] });

    const tl = gsap.timeline();

    paragraphs.forEach((p, index) => {
        if (index === paragraphs.length - 1) return;

        const currentParagraph = paragraphs[index];
        const nextParagraph = paragraphs[index + 1];

        tl
            .to({}, { duration: 1 })
            .to(currentParagraph, {
                autoAlpha: 0,
                y: -30,
                duration: 0.5
            }, '+=0.5')
            .to(stall, {
                height: heights[index + 1],
                duration: 1,
                ease: 'power1.inOut'
            }, '<')

            .to(nextParagraph, {
                autoAlpha: 1,
                y: 0,
                duration: 0.5
            });
    });

    ScrollTrigger.create({
        animation: tl,
        trigger: section,
        pin: stall,
        start: 'top 20%',
        end: '+=800',
        scrub: 1,
        markers: false,
        invalidateOnRefresh: true,
    });
}

function initPrivacyNavPin() {

    const menuNavegacao = document.querySelector('.privacidade__nav-content');
    const containerTrigger = document.querySelector('.privacidade__grid');

    if (!menuNavegacao || !containerTrigger) {
        return;
    }

    ScrollTrigger.create({
        trigger: containerTrigger,
        pin: menuNavegacao,
        start: 'top 160px',
        end: 'bottom bottom+=200px',
        pinSpacing: false,
        matchMedia: '(min-width: 992px) and (prefers-reduced-motion: no-preference)',
    });
}

export function initGsapAnimations() {
    initSobreStallAnimation();
    initHomeStallAnimation();
    initPrivacyNavPin();
    initAnimCasesPremiados();
}